module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('h2', [_vm._v("订单查询")]), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "40px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "订单号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.id),
      expression: "form.id"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.id)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.id = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "联系人手机"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.customerPhone),
      expression: "form.customerPhone"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.customerPhone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.customerPhone = $event.target.value
      }
    }
  })])], 1), _vm._v(" "), _c('v-form', {
    staticStyle: {
      "width": "100%",
      "margin-top": "30px"
    },
    attrs: {
      "label-width": "6em",
      "model": _vm.form
    }
  }, [_c('v-form-item', {
    attrs: {
      "label": "产品编号"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productNo),
      expression: "form.productNo"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productNo)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productNo = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-form-item', {
    attrs: {
      "label": "产品关键字"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.productName),
      expression: "form.productName"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.form.productName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.form.productName = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.searchOrder
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('h2', [_vm._v("查询结果"), _c('v-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.exportExcel
    }
  }, [_vm._v("导出订单")])], 1), _vm._v(" "), _c('v-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.isLoading),
      expression: "isLoading"
    }],
    staticStyle: {
      "width": "100%",
      "background-color": "#FFF",
      "margin-top": "20px"
    },
    attrs: {
      "data": _vm.tableData,
      "column": _vm.tableColumn
    },
    scopedSlots: _vm._u([{
      key: "productInfo",
      fn: function(props) {
        return [_c('div', [_vm._v("产品名称：" + _vm._s(props.data.productName))]), _vm._v(" "), _c('div', [_vm._v("产品编号：" + _vm._s(props.data.productNo))]), _vm._v(" "), _c('div', [_vm._v("货号：" + _vm._s(props.data.goodsNo))])]
      }
    }, {
      key: "customerInfo",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(props.data.customerName))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerPhone))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(props.data.customerAddress))])]
      }
    }, {
      key: "action",
      fn: function(props) {
        return [_c('div', [_vm._v(_vm._s(_vm._f("formatOrderStatus")(props.data.deliveryNo)))]), _vm._v(" "), _c('div', {
          staticClass: "refuse-btn",
          on: {
            "click": function($event) {
              _vm.showRefuseRefundDialog(props.data)
            }
          }
        }, [_vm._v("拒绝退款")]), _vm._v(" "), _c('div', {
          staticClass: "allow-btn",
          on: {
            "click": function($event) {
              _vm.showAllowRefundDialog(props.data)
            }
          }
        }, [_vm._v("允许退款")])]
      }
    }])
  }), _vm._v(" "), _c('v-pagination', {
    staticStyle: {
      "text-align": "right"
    },
    attrs: {
      "current": _vm.currentPage,
      "total": Math.ceil(_vm.totalCount / 20),
      "size": 'md',
      "first": false,
      "last": false
    },
    on: {
      "current-change": function($event) {
        _vm.currentChangeFunc($event)
      }
    }
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "拒绝退款",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.refuseRefundDialog),
      callback: function($$v) {
        _vm.refuseRefundDialog = $$v
      },
      expression: "refuseRefundDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("拒绝原因：")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "placeholder": "请选择"
    },
    model: {
      value: (_vm.refuse_reason_val),
      callback: function($$v) {
        _vm.refuse_reason_val = $$v
      },
      expression: "refuse_reason_val"
    }
  }, _vm._l((_vm.REFUSE_REASON), function(item, key) {
    return _c('v-option', {
      key: key,
      attrs: {
        "label": item,
        "value": item
      }
    })
  }))], 1)]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.refuseRefund
    }
  }, [_vm._v("拒绝退款")])])]), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "title": "允许退款",
      "modalAppendToBody": false
    },
    model: {
      value: (_vm.allowRefundDialog),
      callback: function($$v) {
        _vm.allowRefundDialog = $$v
      },
      expression: "allowRefundDialog"
    }
  }, [_c('ul', [_c('li', [_c('label', [_vm._v("退款备注：")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.refund_reason_val),
      expression: "refund_reason_val"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.refund_reason_val)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.refund_reason_val = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default",
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-warning",
    on: {
      "click": _vm.allowRefund
    }
  }, [_vm._v("允许退款")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13ae6b64","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/wenchuang/refundOrder/Main.vue
// module id = 943
// module chunks = 0